module.exports = __webpack_public_path__ + "img/A3z.710fde99.jpg";